import FakeCartModal from "./FakeCartModal";
export default FakeCartModal;
